
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import VendedorData, { VendedorDataValidations } from "./VendedorData";
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import loadsh from "lodash";

export default {
  name: "app-vendedor-form",
  components: {
    VueSelect,
  },
  props: {
    url: {
      type: String,
    },
    vendedor: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      cidades: [],
      consultandoCep: false,
    };
  },
  validations: {
    form: VendedorDataValidations,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  watch: {
    vendedor(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.preencherFormulario(newValue);
      }
    },
  },
  methods: {
    setAtivo() {
      this.form.status = this.form.status == true ? false : true;
    },
    preencherFormulario(dados) {
      this.form = new VendedorData(dados || {});
      this.cidades = this.form.cidade ? [this.form.cidade] : [];
    },
    setCidade(cidade) {
      this.form.cidade = cidade || null;
      this.form.id_cidade = cidade ? cidade.id_cidade : null;
    },
    onSearchCidade(search, loading) {
      if (!search.length) {
        return;
      }

      loading(true);
      this.searchCidade(loading, search, this);
    },
    searchCidade: loadsh.debounce(async (loading, search, vm) => {
      vm.cidades = await vm.getCidade(search);
      loading(false);
    }, 350),
    async consultaCep() {
      if (!this.form.cep) {
        this.$toast.warning("Informe um CEP para consultar.");
        return;
      }

      this.consultandoCep = true;

      try {
        const cep = await this.getCep(this.form.cep);

        if (!cep || cep.erro || (Array.isArray(cep) && cep.length === 0)) {
          this.$toast.warning("Confira o CEP informado!");
          return;
        }

        this.form.logradouro = cep.logradouro || "";
        this.form.bairro = cep.bairro || "";
        this.cidades = await this.getCidadeByUF(cep.localidade, cep.uf);

        if (this.cidades.length) {
          this.setCidade(this.cidades[0]);
        }
      } finally {
        this.consultandoCep = false;
      }
    },
    async getDataInit() {
      this.preencherFormulario(this.vendedor);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_vendedor_novo"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        const payload = {
          ...this.form,
          id_cidade: this.form.cidade
            ? this.form.cidade.id_cidade
            : this.form.id_cidade,
        };
        delete payload.cidade;

        await this.$http.post(this.url, payload);

        this.$router.push({ name: "vendedorLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
